import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLDOJISTAR', label: 'Doji Star', lookback: 11 })
